import { colors, Divider, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthGuard, ErrorMessage, GenericHeader, LoadingIndicator, Page, RenderGuard } from "components";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Product } from "services";
import { ModelsActions } from "store/actions";
import { ecommerce_manager } from 'utils/constants';
import useErrorCatcher from "utils/useErrorCatcher";
import useRouter from 'utils/useRouter';
import { Summary } from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  tabs: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

let mounted = false;

const TopupOptionDetail = props => {
  const { match, history } = props;
  const classes = useStyles();
  const { topup_option_id, tab } = match.params;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const model = useSelector(state => state.models.topup_option);
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    reload();

    // eslint-disable-next-line
  }, [topup_option_id]);

  useEffect(() => {
    mounted = true;
    return () => {
      mounted = false;
    }
  }, []);

  const reload = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      const { model } = await Product.detail(topup_option_id);
      dispatch(ModelsActions.update_model({ topup_option: model }));
    }).finally(() => setLoading(false));
  }

  const handleTabsChange = (event, value) => {
    history.push(value);
  };

  const tabs = [
    { value: "summary", label: "Summary" },
  ];

  if (!tab) {
    return <Redirect to={`/topup-options/${topup_option_id}/summary`} />;
  }

  if (!tabs.find(t => t.value === tab)) {
    return <Redirect to="/errors/error-404" />;
  }

  const handleDelete = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      await Product.del(topup_option_id);
      router.history.push('/topup-options');
    }).finally(() => mounted && setLoading(false));
  }

  return (
    <AuthGuard roles={[ecommerce_manager]} projects={[]}>
      <Page className={classes.root} title="Topup Option Details" >
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator variant="card" active={loading} />
        <RenderGuard renderIf={!loading && model}>
          {model && <GenericHeader subheader={model.name_en} header="Topup Option" subtitle={model.reference} />}
          <Tabs
            className={classes.tabs}
            onChange={handleTabsChange}
            scrollButtons="auto"
            value={tab}
            variant="scrollable" >
            {tabs.map(tab => <Tab key={tab.value} label={tab.label} value={tab.value} />)}
          </Tabs>
          <Divider className={classes.divider} />
          <div className={classes.content}>
            {tab === "summary" && <Summary handleDelete={handleDelete} reload={reload} />}
          </div>
        </RenderGuard>
      </Page>
    </AuthGuard>
  );
};

TopupOptionDetail.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default TopupOptionDetail;
